import { displayLabel } from "../../utils/displayLabel";
import React, { useEffect, useState } from "react";
import { getAuthorGenreCounts } from "../../services/authorFollowerCount";

const genreRingMap = {
  fantasy: "border-genreRings-fantasy", romantasy: "border-genreRings-romantasy",
  romance: "border-genreRings-romance", western: "border-genreRings-western",
  horror: "border-genreRings-horror", "science fiction": "border-genreRings-scifi",
  "mystery / crime": "border-genreRings-mystery", "thriller / suspense": "border-genreRings-thriller",
  thriller: "border-genreRings-thriller", suspense: "border-genreRings-thriller",
  mystery: "border-genreRings-mystery", crime: "border-genreRings-crime",
  "non-fiction": "border-genreRings-nonfiction", nonfiction: "border-genreRings-nonfiction",
  "non fiction": "border-genreRings-nonfiction", christian: "border-genreRings-christian",
  "christian fiction": "border-genreRings-christian", "bookish circle": "border-genreRings-bookishCircle",
  "historical fiction": "border-genreRings-historical", "children's books": "border-genreRings-children",
  "literary fiction": "border-genreRings-literaryFiction",
};

export default function AuthorGenreCounts() {
  const [genres, setGenres] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    let pending = false;
    const load = async () => {
      if (pending || controller.signal.aborted) return;
      pending = true;
      try {
        const next = await getAuthorGenreCounts({ signal: controller.signal });
        if (!controller.signal.aborted) { setGenres(next); setError(false); }
      } catch {
        if (!controller.signal.aborted) setError(true);
      } finally { pending = false; }
    };
    const refreshVisible = () => { if (document.visibilityState === "visible") load(); };
    load();
    window.addEventListener("focus", refreshVisible);
    document.addEventListener("visibilitychange", refreshVisible);
    const interval = setInterval(refreshVisible, 60000);
    return () => {
      controller.abort();
      clearInterval(interval);
      window.removeEventListener("focus", refreshVisible);
      document.removeEventListener("visibilitychange", refreshVisible);
    };
  }, [retry]);

  return <div className="mt-3 space-y-2" aria-live="polite">
    <p className="text-sm text-bookish-purpleAccent">Readers following your books’ genres across Bookish Circle.</p>
    {error ? <p role="alert">Genre counts are unavailable. <button type="button"
      onClick={() => setRetry((value) => value + 1)} className="underline">Retry genre counts</button></p>
      : genres === null ? <p>Loading genre circles...</p>
      : genres.length === 0 ? <p>Add genres to your books to see your genre circles here.</p>
      : genres.map(({ genre, readers }) => <div key={genre} className="flex justify-between items-center gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <span aria-hidden="true" className={`inline-block h-3 w-3 rounded-full border-2 bg-transparent shrink-0 ${genreRingMap[genre.toLowerCase()] || "border-bookish-purple"}`} />
          <span className="font-semibold">{displayLabel(genre)}</span>
        </div>
        <span className="tabular-nums whitespace-nowrap" aria-label={`${displayLabel(genre)}: ${readers} readers`}>
          <strong>{readers.toLocaleString()}</strong> {readers === 1 ? "reader" : "readers"}
        </span>
      </div>)}
  </div>;
}
